import { render, staticRenderFns } from "./PatreonPremiumButton.vue?vue&type=template&id=c9e0cf10&scoped=true"
import script from "./PatreonPremiumButton.vue?vue&type=script&lang=js"
export * from "./PatreonPremiumButton.vue?vue&type=script&lang=js"
import style0 from "./PatreonPremiumButton.vue?vue&type=style&index=0&id=c9e0cf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e0cf10",
  null
  
)

export default component.exports